import React, { ReactNode, useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface ConfigWrapperProps {
  heading: string;
  children: ReactNode;
  customStyles?: Record<string, string>;
  isCollapsable?: boolean;
}

const ConfigWrapper: React.FC<ConfigWrapperProps> = ({
  heading,
  children,
  customStyles = {},
  isCollapsable = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(true); // Default to expanded

  const handleToggle = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <Typography
          sx={{
            color: "#227C9D",
            fontSize: { xs: "1rem", md: "1.2rem", lg: "1.5rem", xl: "1.8rem" },
            fontWeight: "600",
            marginTop: "1rem",
            ...customStyles,
          }}
        >
          {heading}
        </Typography>
        {isCollapsable && (
          <IconButton
            onClick={handleToggle}
            size="small"
            sx={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.3s ease",
              marginTop: "10px",
            }}
          >
            <ExpandMoreIcon />
          </IconButton>
        )}
      </Box>
      <Box
        sx={{
          border: "1px solid #227C9D", // Always apply the border
          borderRadius: "0.5rem",
          display: isExpanded ? "block" : "none", // Ensure no space is occupied when collapsed
          padding: isExpanded ? 2 : 0,
          marginTop: 1,
          maxWidth: "95%",
          fontSize: "clamp(0.4rem, 0.8vw + 0.1rem, 1.8rem)",
          // maxHeight: isExpanded ? "500px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.3s ease, opacity 0.3s ease",
          opacity: isExpanded ? 1 : 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ConfigWrapper;
